var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "avatars-personal",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.071068 4.071068l20.857864 20.857864c3.905243 3.905243 3.905243 10.236893 0 14.142136L39.071068 59.928932c-3.905243 3.905243-10.236893 3.905243-14.142136 0L4.071068 39.071068c-3.905243-3.905243-3.905243-10.236893 0-14.142136L24.928932 4.071068c3.905243-3.905243 10.236893-3.905243 14.142136 0z",
    stroke: "#FFF",
    strokeWidth: 2,
    fill: "#FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 29.5c4.970563 0 9 4.029437 9 9v6.4375C41 46.076587 40.076587 47 38.9375 47h-13.875C23.923413 47 23 46.076587 23 44.9375V38.5c0-4.970563 4.029437-9 9-9zm0-1.5c3.58985 0 6.5-2.91015 6.5-6.5S35.58985 15 32 15s-6.5 2.91015-6.5 6.5S28.41015 28 32 28z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartup);
export default __webpack_public_path__ + "static/media/startup.d2dc296aebbe08eb5ea9a56f79b1436c.svg";
export { ForwardRef as ReactComponent };